import {
  IStandardAPIResponse,
  ISLAMatrix,
  ISLANotes,
  ISLADeviation
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getSLAMatrixConfig(customerId: string): Promise<IStandardAPIResponse<ISLAMatrix>> {
  try {
    let res = await httpClient<ISLAMatrix>(
      `sla-matrix-configurations?customerId=${customerId}`,
      "GET",
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addOrUpdateSLAMatrixConfig(
  data: ISLAMatrix
): Promise<IStandardAPIResponse<ISLAMatrix>> {
  try {
    let res = await httpClient<ISLAMatrix>(`sla-matrix-configurations`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getSLANotes(searchObj: {
  customerId: string,
}): Promise<IStandardAPIResponse<Array<ISLANotes>>> {
  try {
    let res = await httpClient<Array<ISLANotes>>(
      `sla-notes`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addSLANotes(
  data: ISLANotes
): Promise<IStandardAPIResponse<ISLANotes>> {
  try {
    let res = await httpClient<ISLANotes>(`sla-notes`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateSLANotes(
  data: ISLANotes
): Promise<IStandardAPIResponse<ISLANotes>> {
  try {
    let res = await httpClient<ISLANotes>(`sla-notes/${data._id}`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteSLANotes(
  data: ISLANotes
): Promise<IStandardAPIResponse<ISLANotes>> {
  try {
    let res = await httpClient<ISLANotes>(`sla-notes/${data._id}`, "DELETE", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function getSLADeviation(searchObj: {
  customerId: string,
  date: Date | string
}): Promise<IStandardAPIResponse<Array<ISLADeviation>>> {
  try {
    let res = await httpClient<Array<ISLADeviation>>(
      `sla-deviation`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addSLADeviation(
  data: ISLADeviation
): Promise<IStandardAPIResponse<ISLADeviation>> {
  try {
    let res = await httpClient<ISLADeviation>(`sla-deviation`, "PUT", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateSLADeviation(
  data: ISLADeviation
): Promise<IStandardAPIResponse<ISLADeviation>> {
  try {
    let res = await httpClient<ISLADeviation>(`sla-deviation/${data._id}`, "PATCH", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteSLADeviation(
  data: ISLADeviation
): Promise<IStandardAPIResponse<ISLADeviation>> {
  try {
    let res = await httpClient<ISLADeviation>(`sla-deviation/${data._id}`, "DELETE", data);
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}